module.exports = "https://qp-assets.quero.com/assets/images/credit-card-brands/credit-card.svg?73b7da9ade4db293c6aa6e4f2ea47ce1";